import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import CasinoIcon from '@material-ui/icons/Casino';
import TextField from '@material-ui/core/TextField';
import DiceUtil from '../utils/DiceUtil'
import withRoot from "../withRoot";

const styles = theme => ({
    root: {
        margin: theme.spacing.unit,
    },
});

class DiceRoller extends Component {
    state = {
        rollCount: 1,
        faces: 6,
        offset: 0,
        result: null,
        rollCountWidth: 26,
        facesWidth: 26,
        offsetWidth: 26,
    };

    handleChange = name => event => {
        let value = event.target.value;
        if (name !== "offset" && value < 1) value = 1;

        this.setState({
            [name]: value,
            [name + "Width"]: value.length * 9 + 17,
        });
    };

    rollClick = () => {
        let rollString = "";
        let result = Number(this.state.offset);
        const rollCount = Number(this.state.rollCount);
        const faces = Number(this.state.faces);

        if (rollCount >= 1000000) {
            result += ((faces + 1) / 2) * rollCount;
            result = Math.floor(result);
            result = " = " + result + " [ warning: too many rolls, average calculated instead ]";
        }
        else {
            for (let i = 0; i < rollCount; i++) {
                let roll = DiceUtil.dice(faces);
                result += roll;
                rollString += roll + " ";
            }
            result = " = " + result + " [ " + rollString + "]";
        }
        this.setState({ result: result });
    };

    render() {
        const { classes } = this.props;

        return (
            <Typography component="div" className={classes.root}>
                <TextField
                    id="rollCount"
                    value={this.state.rollCount}
                    onChange={this.handleChange('rollCount')}
                    type="number"
                    style={{ width: this.state.rollCountWidth }}
                />

                d

                <TextField
                    id="faces"
                    value={this.state.faces}
                    onChange={this.handleChange('faces')}
                    type="number"
                    style={{ width: this.state.facesWidth }}
                />

                +

                <TextField
                    id="offset"
                    value={this.state.offset}
                    onChange={this.handleChange('offset')}
                    type="number"
                    style={{ width: this.state.offsetWidth }}
                />

                <IconButton color="inherit" aria-label="Menu" onClick={this.rollClick}>
                    <CasinoIcon />
                </IconButton>

                {this.state.result}
            </Typography>
        );
    }
}

DiceRoller.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRoot("Dice Roller", withStyles(styles)(DiceRoller));


// WEBPACK FOOTER //
// ./src/dice-roller/DiceRoller.js